import { render, staticRenderFns } from "./webShare.vue?vue&type=template&id=c7424882&scoped=true&lang=pug"
import script from "./webShare.vue?vue&type=script&lang=js"
export * from "./webShare.vue?vue&type=script&lang=js"
import style0 from "./webShare.vue?vue&type=style&index=0&id=c7424882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7424882",
  null
  
)

export default component.exports